import { useMemo, useState } from "react";

import { useCallback } from "react";

import {
  PriorClaimsForm,
  priorClaimsFormValidation,
} from "@covertree/new-business-forms";
import { PriorClaim } from "@covertree/new-business-graphql";
import {
  mapPriorClaimsToPriorClaimsFormInputs,
  mapPriorClaimsFormInputsToPriorClaims,
} from "@covertree/new-business-mappings";
import { useFormWithNotification } from "@covertree/hooks";
import { FORM_ERROR_DELAY_IN_MS } from "@covertree/consts";
import { yupResolver } from "@hookform/resolvers/yup";

import { FormProvider, Resolver } from "react-hook-form";
import { Form } from "@covertree/ui";
import {
  selectPersonalDetailsFormDefaultValues,
  selectPriorClaims,
  useNewBusinessSelector,
} from "@covertree/new-business-redux";
import { ClaimsListForm } from "@covertree/new-business-past-claims";

function ClaimsList({
  onClaimsListSubmit,
  isD2C,
}: {
  onClaimsListSubmit: (priorClaims: PriorClaim[]) => Promise<void>;
  isD2C?: boolean;
}) {
  const priorClaims = useNewBusinessSelector(selectPriorClaims);
  const { firstName, lastName } = useNewBusinessSelector(
    selectPersonalDetailsFormDefaultValues
  );

  const [isFormSubmitting, setIsFormSubmitting] = useState<boolean>(false);

  const defaultValues: PriorClaimsForm = useMemo(
    () => ({
      claims: mapPriorClaimsToPriorClaimsFormInputs(
        priorClaims,
        `${firstName}|${lastName}`
      ),
    }),
    [priorClaims, firstName, lastName]
  );

  const form = useFormWithNotification({
    mode: "all",
    reValidateMode: "onChange",
    delayError: FORM_ERROR_DELAY_IN_MS,
    defaultValues,
    resolver: yupResolver(
      priorClaimsFormValidation
    ) as Resolver<PriorClaimsForm>,
  });

  const { handleSubmit } = form;

  const handleSubmitClaimsForm = useCallback(
    async (formData: PriorClaimsForm) => {
      setIsFormSubmitting(true);
      try {
        const transformedClaims = mapPriorClaimsFormInputsToPriorClaims(
          formData.claims
        );
        await onClaimsListSubmit(transformedClaims);
      } finally {
        setIsFormSubmitting(false);
      }
    },
    [onClaimsListSubmit]
  );
  return (
    <FormProvider {...form}>
      <Form onSubmit={handleSubmit(handleSubmitClaimsForm)}>
        <ClaimsListForm
          priorClaimsCount={priorClaims.length}
          loading={isFormSubmitting}
          isD2C={isD2C}
        />
      </Form>
    </FormProvider>
  );
}

export { ClaimsList };
